import React, { useEffect, useState } from "react";
import styles from "./classifier.module.css";
import Assistant from "../../../components/molecules/ai-tutor/Assistant/Assistant";
import TutorSubjects from "../../../components/molecules/ai-tutor/TutorSubjects/TutorSubjects";
import { isEmptyOrNull } from "../../../utils/common-utils";
import { useTutor } from "../../../context/AiTutorContext";
import UserText from "../../../components/molecules/ai-tutor/Assistant/UserText";
import { useRoot } from "../../../context/RootContext";
import TutorSchoolAISubjects from "../TutorSchoolAISubjects";
import TopicSelector from "../../../components/molecules/TopicSelector/TopicSelector";
import {
  getUserName,
  handleNavigateFeeback } from
"../../../utils/TutorConstants";
import { FaInfoCircle } from "react-icons/fa";
import { Box } from "@chakra-ui/react";
import { useLocation } from "@remix-run/react";
import { WelcomeClassifierStyles } from "./WelcomeClassifier.styles";

export default function WelcomeClassifier(props) {
  const { loader, topic, classifierInfo, isDoubt, isLearn } = useTutor();
  const { isStandaloneWithSubjectMapping, isStandalone, playgroundMode, taskType } =
  useRoot();
  const {
    classifierQuery,
    classifierText,
    classifierHistory,
    classifierStatus
  } = classifierInfo;
  const [hasHydrated, setHasHydrated] = useState(false);
  const location = useLocation();

  let isDoubtScreen =
  location?.pathname.includes("/doubt") || playgroundMode === "Doubt";

  const isLearnFlow = taskType === "learn" || taskType === "learnSubtopic";

  useEffect(() => {
    setHasHydrated(true);
  }, []);

  if (!hasHydrated) {
    return null;
  }

  const getTitle = () => {
    if (isDoubt) {
      if (isStandaloneWithSubjectMapping) {
        return `Hi ${getUserName()}! This is your space to ask anything you want.`;
      }
      return `Hi ${getUserName()}! This is your space to ask anything you want.`;
    } else if (isLearn) {
      return `Hi, Please select a topic to learn`;
    } else {
      if (isStandaloneWithSubjectMapping) {
        return `Hey ${getUserName()}, Practice makes powerhouses. `;
      }
      return "Let’s get practicing!";
    }
  };
  return (
    <div className={styles.container}>
      {props?.showChatIcon &&
      <Box position={"absolute"} right={2} top={2} zIndex={1000}>
          <FaInfoCircle
          cursor={"pointer"}
          onClick={() => {
            handleNavigateFeeback(props?.chatId);
          }}
          size={24} />

        </Box>
      }
      {isEmptyOrNull(topic) &&
      <React.Fragment>
          {(isStandalone || isStandaloneWithSubjectMapping || isDoubt) &&
        <Assistant text={getTitle()} />
        }
          {isStandalone && !isStandaloneWithSubjectMapping &&
        <TutorSubjects
          isDoubtScreen={isDoubtScreen}
          handleSelect={props?.handleSelect} />

        }
          {(isStandaloneWithSubjectMapping ||
        props?.subject &&
        props?.subjectMasterUuid &&
        props?.topicName &&
        props?.topicMasterUuid &&
        props?.subjectName &&
        props.topicName) &&
        <TopicSelector
          openFull={true}
          subject={props?.subject}
          subjectMasterUuid={props?.subjectMasterUuid}
          topic={props?.topicName}
          topicMasterUuid={props?.topicMasterUuid}
          subjectName={props?.subjectName}
          topicName={props?.topicName} />

        }
        </React.Fragment>
      }

      {!isLearnFlow &&
      <Box
        sx={
        !isDoubtScreen ?
        WelcomeClassifierStyles()?.subContainer :
        { marginTop: "30px" }
        }>

          {!isEmptyOrNull(classifierQuery) &&
        <Box
          sx={
          isDoubtScreen &&
          WelcomeClassifierStyles()?.doubtUserWelcomeContainer
          }>

              <UserText text={classifierQuery} isBold={isDoubtScreen && true} />
            </Box>
        }
          {(!isEmptyOrNull(classifierText) ||
        loader && classifierStatus == 3) &&
        <Box
          sx={
          isDoubtScreen &&
          WelcomeClassifierStyles()?.doubtAssistantWelcomeContainer
          }>

                <Assistant
            text={classifierText}
            isWelcomeClassifier={isDoubtScreen && true} />

              </Box>
        }
        </Box>
      }


      {classifierHistory?.length > 0 &&
      classifierHistory?.map((item, index) => {
        const isPracticeScreen = location?.pathname.includes("/practice");

        return (
          <Box
            sx={
            !isDoubtScreen &&
            WelcomeClassifierStyles()?.welcomeClassifierContainer
            }>

              <Box
              key={index}
              sx={!isDoubtScreen && WelcomeClassifierStyles(isLearnFlow)?.subContainer}>

                {!isLearnFlow &&
              <Box
                sx={
                isDoubtScreen &&
                WelcomeClassifierStyles()?.doubtUserWelcomeContainer
                }>

                    <UserText
                  text={item?.query}
                  isClassifier={true}
                  isBold={isDoubtScreen && true} />

                  </Box>
              }

                {isPracticeScreen && isStandalone &&
              <Assistant
                emotionalMessageCode={isLearnFlow ? 9 : 5}
                isEmotionalScript={true} />

              }

                {!isLearnFlow &&
              <Box
                sx={
                isPracticeScreen ?
                WelcomeClassifierStyles()?.hideVinContainer :
                WelcomeClassifierStyles()?.showVinContainer
                }>

                    <Box
                  sx={
                  isDoubtScreen &&
                  WelcomeClassifierStyles()?.doubtAssistantWelcomeContainer
                  }>

                      <Assistant
                    text={item?.answer}
                    hideVin={isStandalone && isPracticeScreen ? true : false}
                    isWelcomeClassifier={isDoubtScreen && true} />

                    </Box>
                  </Box>
              }
              </Box>
            </Box>);

      })}

    </div>);

}